var map = {
	"./Alert-Black.png": 47,
	"./Alert-Gray.png": 2394,
	"./Checkmark.png": 3563,
	"./Checkmarkred.png": 5076,
	"./Dashboard-Black.png": 7094,
	"./Dashboard-Gray.png": 6347,
	"./Faculty-Black.png": 7518,
	"./Faculty-Gray.png": 1758,
	"./Info-Black.png": 4268,
	"./Info-Gray.png": 783,
	"./Notfound.svg": 8582,
	"./Profile-Black.png": 6401,
	"./Profile-Gray.png": 1973,
	"./Report-Black.png": 8521,
	"./Report-Gray.png": 4487,
	"./SHP Structure.pdf": 1058,
	"./SHP icons_black_gray-01.png": 5299,
	"./SHP icons_black_gray-13.png": 1902,
	"./Search-Black.png": 8417,
	"./Search-Gray.png": 3540,
	"./Student-Black.png": 6108,
	"./Student-Gray.png": 9524,
	"./Subscriber-Black.png": 3538,
	"./Subscriber-Gray.png": 9260,
	"./SupportCenter-Black.png": 71,
	"./SupportCenter-Gray.png": 7907,
	"./Users-Black.png": 374,
	"./Users-Gray.png": 7559,
	"./Vitals-Black.png": 8426,
	"./Vitals-Gray.png": 8447,
	"./add.png": 3253,
	"./alert.png": 4734,
	"./avatar.png": 3328,
	"./blood.png": 6717,
	"./chronometer.png": 1229,
	"./healthy.png": 7095,
	"./key.png": 9548,
	"./logo-large.png": 9170,
	"./logo-text.png": 5836,
	"./logo.png": 6338,
	"./monitor.png": 9193,
	"./scans.png": 6971,
	"./search.svg": 2725,
	"./smartphone-call.png": 7336,
	"./soter_logo.png": 1261,
	"./sync.png": 1853,
	"./themometer.png": 1750,
	"./times.svg": 2448,
	"./unhealthy.png": 123,
	"./view.png": 7133,
	"./vitals.png": 4013
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6303;